<div *ngIf="loadingService.visible" class="w-screen h-screen fixed top-0 left-0 z-50 bg-gray-900/70 flex items-center justify-center">
  <div class="text-sm text-gray-300 py-6 px-8 rounded-md select-none border-1 border-white bg-[#0b0b10]/80 flex justify-center items-center">
    <i class="fas fa-cloud fa-beat-fade mr-8 text-green-500" style="--fa-beat-fade-opacity: 0.1; --fa-beat-fade-scale: 1.25;"></i>
    <ul>
      <li *ngFor="let msg of loadingService.messages">{{ msg.text }}</li>
    </ul>
  </div>
</div>
<router-outlet />
